import React, { useState, useEffect } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";

import filterItems from "~libs/filterItems";
import SearcherList from "~styled/searcherList/SearcherList";
import ListView from "~styled/listView/ListView";
import { fetchVehiculoModelos } from "./actions";

export interface Modelo {
  label: string | null;
  value: string | null;
}

interface ReduxState {
  vehiculoModelosReducer: {
    isLoading: boolean;
    modelos: Modelo[];
  };
}

interface VehiculoModeloSelectorProps {
  value: Modelo;
  marca: Modelo;
  anio: Modelo;
  onChange?: (event: { target: { value: Modelo } }) => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  searcher: {
    display: "flex",
    paddingTop: 10,
    flexDirection: "column",
    width: "100%",
    justifyContent: "space-around",
  },
  chip: {
    borderRadius: "6px",
    fontWeight: "bold",
    margin: 2,
    height: "inherit",
    paddingTop: 3,
    paddingBottom: 3,
    whiteSpace: "inherit",
  },
  chipLabel: {
    whiteSpace: "inherit",
  },
}));

const useReduxSelector = () =>
  useSelector((state: ReduxState) => ({
    isLoading: state.vehiculoModelosReducer.isLoading,
    modelos: state.vehiculoModelosReducer.modelos,
  }));

function VehiculoModeloSelector({
  value,
  marca,
  anio,
  onChange,
}: VehiculoModeloSelectorProps): JSX.Element {
  const [filter, setFilter] = useState<string>("");

  const { isLoading, modelos } = useReduxSelector();
  const dispatch = useDispatch();

  useEffect(() => {
    if (marca?.value && anio?.value) {
      dispatch(fetchVehiculoModelos(marca.value, anio.value) as any);
    }
  }, [dispatch, marca?.value, anio?.value]);

  const handleModelItem = (item: Modelo) => {
    setFilter("");
    onChange?.({
      target: { value: { label: item.label, value: item.value } },
    });
  };

  const handleFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilter(event.target.value);
  };

  const classes = useStyles();
  type ListItem = { label: string; value: string | null };

  const baseList: Modelo[] =
    filter === "" ? modelos : (filterItems(modelos, filter) as Modelo[]);

  const listForView: ListItem[] = baseList.map((m) => ({
    label: m.label ?? "",
    value: m.value ?? null,
  }));

  return (
    <>
      {!value?.label && (
        <div className={classes.searcher}>
          <SearcherList
            onClear={() => handleModelItem({ value: null, label: null })}
            filter={filter}
            onChange={handleFilterChange}
            placeholder={"Buscar modelo"}
          />
          <ListView
            isLoading={isLoading}
            onItemSelected={handleModelItem}
            list={listForView}
          />
        </div>
      )}
    </>
  );
}

export default React.memo(VehiculoModeloSelector);
